import { Button, ButtonProps } from '../Button/button.component';
import { useModalContext } from './modal.context';


export const ModalCancelButton: React.FC<ButtonProps> = (props) => {
  const modalContext = useModalContext();

  return (
    <Button disabled={modalContext.loading} {...props} />
  );
};


export const ModalProgressButton: React.FC<ButtonProps> = (props) => {
  const modalContext = useModalContext();

  return (
    <Button loading={modalContext.loading} {...props} />
  );
};
